<template>
   <div>
       <v-layout column>
           <v-flex xs12>
               <v-layout row justify-center>
                   <v-flex shrink>
                        <ToggleButtons v-model="selectedStatus" :options="noteStatus" @input="noteStatusChanged" />
                   </v-flex>
                   <v-flex shrink> 
                        <v-text-field 
                            prepend-icon="search" 
                            label="Search" 
                            v-model="search" 
                            outline mt-0 pt-0>
                        </v-text-field>
                   </v-flex>
               </v-layout>
           </v-flex>
           <v-flex xs12>
                <v-card :key="index" v-for="(note, index) in filterNotes" elevation="0">
                    <v-layout>
                        <v-flex xs12> 
                            <v-divider v-if="index > 0" :key="index" inset></v-divider>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs2>
                            <v-layout row>
                                <v-flex ml-0 mr-0 pl-0 pr-0>
                                    <v-icon color="primary" @click="openNoteDetails(note)">more_vert</v-icon>
                                </v-flex>
                                <v-flex ml-0 mr-0 pl-0 pr-0> 
                                    <v-icon color="primary" v-if="note.photos.length>0">camera_alt</v-icon>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs10>
                            <v-layout column> 
                                <v-flex>
                                    {{note.details}}
                                </v-flex>
                                <v-flex class="text-xs-right">
                                    Raised By {{note.raisedByName}} {{note.raisedAt | formatDate}}
                                </v-flex>
                                <v-flex class="text-xs-right">
                                    <v-icon v-if="note.comments">comment</v-icon>
                                    <span v-if="!note.isClosed">Open: </span>
                                    <span v-if="note.isClosed">Closed By {{note.closedByName}} {{note.closedAt | formatDate}}</span>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" :color="alertLevelColor(note.alertLevel)">fiber_manual_record</v-icon>
                                        </template>
                                        <span>{{alertLevelColorText(note.alertLevel)}}</span>
                                    </v-tooltip>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card>
           </v-flex>
       </v-layout>
        <ForecastingNoteAction 
            :dialog="noteDetailsDialog" 
            :note="selectedNote"  
            :variety="variety"
            @cancel="closeNoteDetails" 
            @saveNote="saveNote">
        </ForecastingNoteAction>
   </div>
</template>

<script>


import ToggleButtons from "@/components/generic/ToggleButtons.vue"
import ForecastingNoteAction from "@/components/forecasting/forecastingNotes/ForecastingNoteAction.vue";
import UtilService from '@/services/utilService.js';
import ForecastingUtilService from '@/services/forecastingUtilService';

export default {
    components: {
        ToggleButtons,
        ForecastingNoteAction
    },
    props: {
        variety: {
            type: Object,
            required: true
        },
        notes: {
            type: Array,
            required: true
        }
    },
    data(){
        return {
        noteStatus: [
            { id: 1, name: "Open"},
            { id: 2, name: "Closed"}
        ],
        selectedStatus: 1,
        noteDetailsDialog: false,
        selectedNote: {},
        search: null
        };
    },
    computed: {
        isOpen() {
            return this.selectedStatus == 1;
        },
        filterNotes() {
            return this.notes.filter(n=> {
                var result = true;
                if(this.selectedStatus == 1) {
                    result = !n.isClosed;
                } else {
                    result = n.isClosed
                }
                if(this.search) {
                    var searchLowerCase = this.search.toLowerCase();
                    return result && (n.details.toLowerCase().indexOf(searchLowerCase) >= 0 
                    || n.raisedByName.toLowerCase().indexOf(searchLowerCase) >= 0
                    || n.closedByName.toLowerCase().indexOf(searchLowerCase) >= 0);
                }
                return result;
            }).sort(UtilService.sortDescending(y => new Date(y.raisedAt)));
        }
    },
    methods: {
        noteStatusChanged(value) {
            this.selectedStatus = value;
        },
        alertLevelColor(alertLavel) {
            return ForecastingUtilService.getAlertLevelColor(alertLavel);
        },
        openNoteDetails(note) {
            this.noteDetailsDialog = true;
            this.selectedNote = Object.assign({},note);
        },
        closeNoteDetails() {
            this.noteDetailsDialog = false;
            this.selectedNote = {};
        },
        saveNote() {
            this.closeNoteDetails();
        },
        alertLevelColorText(alertLavel) {
            switch(alertLavel) {
                case 1:
                    return "Notices";
                case 2: 
                    return "Cautions";
                case 3:
                    return "Criticals";
            }
        },
    },
    created(){
        
    }
}
</script>

<style>

</style>